<template>  
  <div>
    <div class="container" :style="backgroundStyle" @click.self="handleClick">
      <div v-if="!hasAccess" class="Tile-Locked">
        <div class="Tile-Locked-Icon">
          <LockIcon :width="100" :height="100"/>
        </div>
      </div>

      <div class="Toast" @click="handleClick">
        <div class="Text-Container">
          <span class="Text Text-Title">
            {{ title }}
          </span>
          <span class="Text Text-Secondary" v-if="secondary">
            {{ $t('home.durationStep') }} {{ secondary }}
          </span>
          <!-- <div class="Box-Position" @click="handleClick">
            <div class="Text-Container">
                <span class="Round-Box" @click="handleClick">
                  {{ 'Démarrer' }}
                </span>
              </div>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import unstarted from '@/assets/status/noncommenc@3x.png'
import pending from '@/assets/status/encours@3x.png'
import finished from '@/assets/status/finished@3x.png'
import LockIcon from '@/components/layout/svg/LockIcon'

export default {
  name: 'VvDesktopTile',
  components: {
    LockIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false,
      validator(val) {
        return !val || ['unstarted', 'running', 'finished'].includes(val)
      }
    },
    hasAccess: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    icon() {
      if (this.status === 'finished') return finished

      if (this.status === 'running') return pending

      return unstarted
    },
    backgroundStyle() {
      return this.image ? `background: center / cover no-repeat url(${this.image})` : null
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

// .Round-Box {
//   // border-radius: 25px;
//   font-size: 16px;
//   background: $primary;
//   padding: 8px;
//   position: relative;
//   color: #ffff;
// }

.Box-Position {
  width: 95%;
  margin: 10px;
}

.Text-Container {
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;

  .Text {
    display: inline-block;
    width: 100%;
    color: white;
    text-shadow: 3px 3px 4px #000000;
  }

  .Text-Title {
    font-size: 24px;
    font-weight: bold;
  }

  .Text-Secondary {
    font-size: 20px;
  }
}
.container {
  position: relative;
  cursor: pointer;
  border-radius: 48px;
  overflow: hidden;
  width: 95%;
  height: 250px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 10px rgba(216, 216, 216, 0.5);
  transition: all 200ms linear;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 3px 6px 13px rgba(216, 216, 216, 0.8);
  }

  .Tile-Locked {
    position: absolute;
    top: 0;
    left: 0;
    height: 250px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .Tile-Locked-Icon {
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Header-Button-Wrapper {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .Toast {
    width: 100%;
    height:250px;
    color: $font-color;
    display: flex;
    align-items: center;

    .Icon-Container {
      display: inline-block;
      text-align: right;
      width: 10%;

      img {
        height: 20px;
        width: 20px;
      }
    }
  }
}
</style>
